import { Card, Col } from "react-bootstrap";
import { processData } from '../../DynamicData/ProcessData'
import AllServices from './AllServices'
import ShowMoreText from "react-show-more-text";
import { WebType } from '../../DynamicData/WebType'

const Info = () => {
    const executeOnClick = (isExpanded) => {
        console.log(isExpanded);
    }
    return (
        <>
            <AllServices />

            <div className="webType position-relative overflow-hidden text-justify">
                <div className="col-md-11 px-lg-5 px-md-2 px-sm-2 p-lg-5 mx-auto d-flex flex-column justify-content-center my-5 fw-bold">

                    <h3 className="fw-bold pt-3 my-3 text-danger info-title make-website-title text-center"
                        data-aos="zoom-in"
                        data-aos-duration="1000"> Our Web Design Services in Nagpur Always Got You Covered</h3>

                    <p className="lead1 fw-300 mb-3 info-desc text-black"
                        data-aos="fade-up"
                        data-aos-duration="1000"
                        data-aos-delay="400"><span className="fw-normal">Bluecoder </span>is highly proclaimed as the leading website designing company in Nagpur. We offer a wide array of services that includes Website Designing, Website development, Logo Designing, Paid Advertising, SEO, Digital Marketing, and Content Marketing. We've high experience in website designing and development that helps to develop strategies that make your website worth the engagement of every person looking for the products & services your business provides. We can create different types of websites as per the needs of our customers. The types of websites we create are as follows:</p>

                    <div className="row mb-5 d-flex justify-content-center flex-wrap">
                        {WebType.map((process) => (
                            <Col xs={10} md={6} lg={4} className="pb-0 my-3" key={process.id}>
                                <Card className="websitetypeCard cards pb-0"
                                    data-aos="flip-down"
                                    data-aos-duration="1000">
                                    <Card.Body className="d-flex justify-content-center flex-column pb-0">
                                        <Card.Title className="service_title websitetypeTitle text-center">{process.service}</Card.Title>
                                        <Card.Text className="my-3 fw-100 process_desc websitetypeDesc service_desc">
                                            <ShowMoreText
                                                lines={3}
                                                more={<div className="text-center"><br /><button className="info-btn btn btn-outline-danger fw-bold border border-danger mb-0 px-4 rounded-pill border-2" href="#">Show More</button></div>}
                                                less={<div className="text-center"><br /><button className="info-btn btn btn-outline-primary fw-bold border border-primary mb-0 px-4 rounded-pill border-2" href="#">Show Less</button></div>}
                                                onClick={executeOnClick}
                                                expanded={false}
                                                width={320}
                                                truncatedEndingComponent={"..."}
                                                className="fw-100 process_desc websitetypeDesc service_desc"
                                            >{process.desc}
                                            </ShowMoreText></Card.Text>
                                    </Card.Body>
                                </Card>
                            </Col>
                        ))}
                    </div>
                </div>
                <div className="product-device shadow-sm d-none d-md-block"></div>
                <div className="product-device product-device-2 shadow-sm d-none d-md-block"></div>
            </div>

            <div className="aspects position-relative overflow-hidden text-justify">
                <div className="col-md-11 px-lg-5 px-md-2 px-sm-2 p-lg-5 mx-auto d-flex flex-column justify-content-center my-5 fw-bold">
                    <h3 className="fw-bold pt-2 mb-3 text-primary info-title make-website-title text-center"
                        data-aos="zoom-in"
                        data-aos-duration="1000"> What Makes Us The Best Website Designing Company in Nagpur?</h3>

                    <p className="fw-300 mb-3 info-desc text-warning lead1"
                        data-aos="fade-down"
                        data-aos-duration="1000"
                        data-aos-delay="400">As the best website designing company in Nagpur, our main aim is to provide you with a strong digital presence. Our customer-centric approach helps us to deliver websites that are creative, unique, and personalized to imprint a good impression on the mind of your customers. To have you a better understanding of our website designing process, here we are listing it out:</p>

                    <div className="row my-5 d-flex justify-content-center flex-wrap">
                        {processData.map((process) => (
                            <Col xs={10} md={6} lg={6} className="my-3" key={process.id}>
                                <Card className="cards" data-aos="flip-left" data-aos-duration="1000">
                                    <Card.Body className="process_card d-flex justify-content-center flex-column">
                                        <Card.Title className="service_title text-center">{process.icon}</Card.Title>
                                        <Card.Title className="service_title text-center">{process.service}</Card.Title>
                                        <Card.Text className="my-3 fw-100 process_desc service_desc">{process.desc}</Card.Text>
                                    </Card.Body>
                                </Card>
                            </Col>
                        ))}
                    </div>
                </div>
                <div className="product-device shadow-sm d-none d-md-block"></div>
                <div className="product-device product-device-2 shadow-sm d-none d-md-block"></div>
            </div>
        </>
    )
}

export default Info